import { Box, Flex, Button, Image, Text, Heading } from 'rebass';
import { space } from 'styled-system';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useSWR from 'swr';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import styled from '@emotion/styled';
import { CgHome } from "react-icons/cg";
import { BsBookHalf } from 'react-icons/bs';
import { BiBookContent, BiBookHeart, BiNetworkChart, BiMessageRoundedError } from 'react-icons/bi';
import { IoBookOutline } from "react-icons/io5";
import { FaChevronRight, FaChevronDown, FaRegEdit } from "react-icons/fa";
import { useResetCollectionTag } from 'collections/hooks';
import { CurrentCollectionContext } from '../../../collections/current-collection-context';
import { CurrentModalContext } from '../../modal/context';
import { getResourcePath, useChronicleCollectionSWR, useJournalsChaptersSWR } from '../../../collections/api';
import Loading from '../../loading/index';
import Tooltip from '@tippy.js/react';
import FontAwesome from 'react-fontawesome';

import ExpandIcon from '../../../assets/svg/expand-icon';
import CloseIcon from '../../../assets/svg/close-icon';
import { LuBaby, LuStar } from "react-icons/lu";
import { CgRuler } from "react-icons/cg";
import { HiOutlineUserAdd, HiOutlineUsers } from "react-icons/hi";
import wordmark from 'babys-first-year/assets/babyyearbookslabel.svg';
import closeSidebarLogo from 'app/logo/close-sidebar-logo.svg';
import { CollectionAvatar } from 'collections/detail/header/index';
import useRouteFromEntityParams from 'collections/hooks/route-from-entity-params';
import useEntity from 'entities/hooks/use-entity';
import CollectionTitle from 'collections/shared/title';
import BookIcon from 'assets/svg/book';
import InformationIcon from 'assets/svg/Information';
import CollectionTagManagement from 'collections/detail/tag-management/collection';
import MeLink from '../links/me';
import useEntities from 'entities/hooks/use-entities';
import { useMobileCheckHook } from 'story-media/hooks';
import { checkIfPublicRoute } from 'app/form/helper';
import { useDispatch } from 'react-redux';
import { setSidebar, toggleNavigationVisible } from 'ui/actions';
import ListIcon from 'assets/svg/List';
import { useDrawer } from 'contexts/DrawerContext';
import { postMemberEvent } from 'members/api';
import { useGetCurrentMember } from 'auth/hooks';
import { useCurrentMember } from 'members/hooks/index';
import { TooltipWrap } from 'stories/story-detail-header/styled';
import useValue from 'app/hooks/value';
import Modal from 'app/modal/v3/index';
import useEntityActionCreators from 'entities/hooks/use-entity-action-creators';
import store from 'store';
import { useGiftCertificates, useMyAllChildJournals } from 'account-dashboard/hooks';
import { groupJournalsByChild, pickNewestJournalId } from 'child-journals/group-by-child';
import ChildBookSwitcher from './child-book-switcher';

// Last journal the sidebar successfully resolved a journalId for. Used as a fallback
// so routes with no journal id (e.g. /profile) keep showing that journal's chapters
// instead of the list vanishing. Cleared on logout (see auth/logout.js); overwritten
// automatically the moment the user is on a route/entity that resolves a DIFFERENT
// journal, so switching journals naturally supersedes the stored value.
const LAST_JOURNAL_ID_KEY = 'sidebar_last_journal_id';

// Shown once, the first time a member has more than one child/book to switch
// between — not on every subsequent child or year they add.
const SWITCHER_FTUE_KEY = 'child_book_switcher_ftue_watched';

export function findStoryId(locationParams) {
  // Regular expression to match a UUID (example ID format: '113ce2a4-bf8b-407c-aec8-e48bae986ccd')
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  for (let i = locationParams.length - 1; i >= 0; i--) {
    const param = locationParams[i];

    if (uuidRegex.test(param)) {
      return param;
    }
  }

  return null;
}

export const WatchMeGrowOptions = [
  {
    icon: (color = "#64748B") => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M18.125 3.12501C15.5921 3.1366 13.8267 3.45527 12.6392 4.02263C11.513 4.5607 10.8991 5.32445 10.625 6.33464V16.0311C12.0489 14.9777 14.232 14.375 18.125 14.375V3.12501ZM19.375 14.375C19.375 14.7065 19.2432 15.0244 19.0088 15.2588C18.7744 15.4932 18.4565 15.625 18.125 15.625C13.199 15.625 11.5058 16.6186 10.4883 17.8906C10.3697 18.0389 10.1899 18.125 10 18.125C9.81008 18.125 9.63029 18.0382 9.51172 17.8898C8.50105 16.6254 6.80029 15.625 1.875 15.625C1.49801 15.625 1.16777 15.4651 0.941571 15.1994C0.723464 14.943 0.625002 14.6174 0.625002 14.2993V3.12501C0.624694 2.96118 0.656986 2.7988 0.719403 2.64731C0.782118 2.49515 0.87403 2.35678 0.990399 2.24041L1.08155 2.1574C1.17663 2.07947 1.28323 2.01643 1.3973 1.96941C1.54952 1.90669 1.71281 1.87439 1.87744 1.87501L2.35921 1.88071C4.72867 1.92833 6.55579 2.25271 7.89958 2.8947C8.83239 3.34038 9.52557 3.93745 10 4.67774C10.4744 3.93745 11.1676 3.34038 12.1004 2.8947C13.5338 2.20989 15.5176 1.88669 18.1226 1.87501L18.2454 1.88071C18.3271 1.88847 18.4078 1.9043 18.4863 1.92791L18.6027 1.96941L18.7142 2.02149C18.7865 2.06004 18.8551 2.10544 18.9185 2.1574L19.0096 2.24041L19.0926 2.33155C19.1705 2.42663 19.2336 2.53323 19.2806 2.64731C19.343 2.7988 19.3753 2.96117 19.375 3.12501V14.375ZM1.875 14.2993C1.875 14.3368 1.88187 14.3612 1.88721 14.375C5.76997 14.3763 7.95382 14.9823 9.375 16.0319V6.33464C9.10089 5.32445 8.48704 4.5607 7.36084 4.02263C6.17333 3.45527 4.4079 3.1366 1.875 3.12501V14.2993Z" fill={color} />
    </svg>, label: "Book Preview"
  },
  {
    icon: (color = "#64748B") => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
      <path d="M17.9 17.6677H2.1C1.54305 17.6677 1.0089 17.4464 0.615076 17.0526C0.221249 16.6588 0 16.1247 0 15.5677V5.66797H20V15.5677C20 16.1247 19.7788 16.6588 19.3849 17.0526C18.9911 17.4464 18.457 17.6677 17.9 17.6677ZM1.33333 7.00127V15.5677C1.33333 15.771 1.41411 15.966 1.55788 16.1098C1.62908 16.181 1.71359 16.2375 1.80661 16.276C1.89963 16.3145 1.99932 16.3344 2.1 16.3344H17.9C18.1033 16.3344 18.2983 16.2536 18.4421 16.1098C18.5859 15.966 18.6667 15.771 18.6667 15.5677V7.00127H1.33333Z" fill={color} />
      <path d="M20 7.00048H0V2.43393C0 1.87699 0.221249 1.34286 0.615076 0.949044C1.0089 0.555228 1.54305 0.333984 2.1 0.333984H17.9C18.457 0.333984 18.9911 0.555228 19.3849 0.949044C19.7788 1.34286 20 1.87699 20 2.43393V7.00048ZM1.33333 5.66718H18.6667V2.43393C18.6667 2.2306 18.5859 2.0356 18.4421 1.89183C18.2983 1.74805 18.1033 1.66728 17.9 1.66728H2.1C1.89667 1.66728 1.70166 1.74805 1.55788 1.89183C1.41411 2.0356 1.33333 2.2306 1.33333 2.43393V5.66718Z" fill={color} />
      <path d="M10.3928 0.699577L8.55225 6.11523L9.81467 6.54425L11.6552 1.12859L10.3928 0.699577Z" fill={color} />
      <path d="M15.53 0.699256L13.6904 6.11523L14.9529 6.54403L16.7925 1.12805L15.53 0.699256Z" fill={color} />
      <path d="M5.04463 0.703483L3.2041 6.11914L4.46653 6.54816L6.30705 1.1325L5.04463 0.703483Z" fill={color} />
      <path d="M8.85328 14.7006C8.65702 14.7006 8.4688 14.6226 8.33002 14.4838C8.19125 14.3451 8.11328 14.1568 8.11328 13.9606V9.29405C8.11374 9.16139 8.14986 9.0313 8.21784 8.91739C8.28583 8.80348 8.38319 8.70994 8.49973 8.64656C8.61626 8.58318 8.7477 8.55229 8.88027 8.55713C9.01284 8.56197 9.14167 8.60236 9.25328 8.67407L12.8799 11.0073C12.9831 11.0746 13.0679 11.1665 13.1266 11.2747C13.1852 11.383 13.216 11.5042 13.216 11.6273C13.216 11.7505 13.1852 11.8717 13.1266 11.9799C13.0679 12.0882 12.9831 12.1801 12.8799 12.2473L9.25328 14.5872C9.13367 14.6628 8.99476 14.7022 8.85328 14.7006ZM9.44661 10.374V12.8673L11.3799 11.6273L9.44661 10.374Z" fill={color} />
    </svg>, label: "Video Preview"
  },
];

export const MyBooksOptions = [
  { icon: (color = "#64748B") => <BiBookHeart color={color} size={20} />, label: "Cover" },
  { icon: (color = "#64748B") => <IoBookOutline color={color} size={20} />, label: "Organize Stories" },
  { icon: (color = "#64748B") => <BsBookHalf color={color} size={20} />, label: "Organize Chapters" },
  { icon: (color = "#64748B") => <BookIcon style={{ minWidth: 20 }} size={20} color={color} />, label: "Book Layout" },
];

// Sidebar options configuration
const SidebarOptions = [
  { icon: (color = "#64748B") => <CgHome color={color} size={20} />, label: "All Stories" },
  { icon: (colour = "#64748B") => <ListIcon color={colour} />, label: "Chapters" },
  { icon: (color = "#64748B") => <FaRegEdit size={20} color={color} />, label: "Edit Chapters" },
  { icon: (color = "#64748B") => <HiOutlineUserAdd size={20} color={color} />, label: "Request a Story" },
  { icon: (color = "#64748B") => <LuStar size={20} color={color} />, label: "Milestones" },
  { icon: (color = "#64748B") => <LuBaby style={{ minWidth: 20 }} size={20} color={color} />, label: "Watch Me Grow" },
  { icon: (color = "#64748B") => <CgRuler style={{ minWidth: 20 }} size={20} color={color} />, label: "Growth Chart" },
  { icon: (color = "#64748B") => <BiNetworkChart style={{ minWidth: 20 }} size={20} color={color} />, label: "Talking Family Tree" },
  { icon: (color = "#64748B") => <BookIcon style={{ minWidth: 20 }} size={20} color={color} />, label: "My Book" },
];

const ExtrasSection = (replace, route) => [
  // { icon: (color = "#64748B") => <NotificationsIcon color={color} />, label: "Notification" },
  // { icon: (color = "#64748B") => <SettingsIcon color={color} />, label: "Settings" },
  { icon: (color = "#64748B") => <BiMessageRoundedError style={{ minWidth: 20 }} size={20} color={color} />, label: "Help & Feedback", onClick: () => window.Beacon('open') },
];

let previousOptionSelection = null

const NavigationSidebar = ({ onCollectionClick, closeSidebar = false, setCloseSidebar }) => {
  const { replace, push } = useHistory();
  const { setCurrentCollection } = useContext(CurrentCollectionContext);
  const { revalidateSidebar } = useContext(CurrentModalContext);
  const resetCollectionTag = useResetCollectionTag();
  const isFromMobile = useMobileCheckHook()
  const dispatch = useDispatch();
  const { openFirstTimeUserModal } = useDrawer();

  useGetCurrentMember()
  const { pathname } = useLocation();
  const locationParams = pathname.split('/');

  function getCurrentSelectedOption() {
    if (locationParams[4])
      return 'Chapters';

    return 'All Stories';
  }

  const [selectedOption, setSelectedOption] = useState(getCurrentSelectedOption());
  const [showWatchMeGrowOptions, setShowWatchMeGrowOptions] = useState(false);
  const [showMyBooksOptions, setShowMyBooksOptions] = useState(false);

  useEffect(() => {
    if (pathname.includes('profile')) {
      setSelectedOption('profile')
    }
    else if (pathname.includes('watch-me-grow') || pathname.includes('collage-preview') || pathname.includes('video-preview')) {
      setSelectedOption('Watch Me Grow')
      setShowWatchMeGrowOptions(true)
      setShowMyBooksOptions(false)
    }
    else if (pathname.includes('story-request')) {
      setSelectedOption('Request a Story')
      setShowMyBooksOptions(false)
    }
    else if (pathname.includes('chapters')) {
      setSelectedOption('Chapters')
      setShowMyBooksOptions(false)
    }
    else if (pathname.includes('milestones')) {
      setSelectedOption('Milestones')
      setShowMyBooksOptions(false)
    }
    else if (pathname.includes('book-creation')) {
      setSelectedOption('My Book')
      setShowMyBooksOptions(true)
    }
    else if (pathname.includes('growth-chart')) {
      setSelectedOption('Growth Chart')
      setShowMyBooksOptions(false)
    }
    else if (pathname.includes('family-tree')) {
      setSelectedOption('Talking Family Tree')
      setShowMyBooksOptions(false)
    }
    else if (pathname.includes('child-journals')) {
      setSelectedOption('All Stories')
      setShowMyBooksOptions(false)
    }
  }, [pathname])

  const [showOptions, setShowOptions] = useState(!!locationParams[4]);
  const [currentChapterId, setCurrentChapterID] = useState(!!locationParams[4]);
  const childJournals = useEntities('child-journals');
  const allJournalIds = Object.keys(childJournals).filter(id => !(childJournals[id]?.['subject-name']?.toLowerCase().includes("tap for intro") || childJournals[id]?.['subject-name']?.toLowerCase().includes('sample child journal')))

  const isStoriesLink = locationParams.includes('story') || locationParams.includes('stories')
  const storyId = findStoryId(locationParams);
  const member = useCurrentMember();
  // `/account/setup/:journalId` carries the journal in the third segment. It
  // isn't under /child-journals, so the generic branch below misses it and the
  // sidebar would fall back to an arbitrary journal (allJournalIds[0], or the
  // sticky LAST_JOURNAL_ID_KEY) — highlighting and loading the wrong book while
  // the customer sets up a different one.
  //
  // `/account/certificate/:id` deliberately does NOT match: that id is a gift
  // certificate, not a journal.
  const accountSetupJournalId =
    locationParams[1] === 'account' && locationParams[2] === 'setup' ? locationParams[3] || '' : ''

  const { entity: storyEntity } = useEntity({
    id: isStoriesLink ? storyId : (accountSetupJournalId || locationParams[2]),
    type: isStoriesLink ? 'stories' : 'child-journals'
  });
  const { entity: memberSettings } = useEntity(member?.settings)

  const isOnFreeTrial = storyEntity?.['free-trial'] || false;

  const actualPathname = (locationParams[2] && (locationParams[2] !== 'get-started' && locationParams[1] === 'child-journals') ? locationParams[2] : '')

  // Remember it so the fallback above survives a route/page that doesn't itself
  // resolve a journal id. Whenever the route DOES resolve one (even a different
  // journal than before), this overwrites the stored value — "changes the journal"
  // naturally invalidates the old sticky one.
  const child_journals = useEntities('child-journals')
  const { journals, revalidate: revalidateJournals } = useMyAllChildJournals();
  const { giftCertificates } = useGiftCertificates();

  const sortedJournalIds = Object.keys(child_journals || {})
    .filter((id) => {
      const state =
        child_journals?.[id]?.state ||
        child_journals?.[id]?.attributes?.state;

      return state === "initialized"
      // && !giftCertificates.find(gift => gift.childJournalId === id);
    })

  // When nothing else names a journal, land in the most recently created one —
  // a member who just added a new child or a new year should land there, not
  // on an arbitrary (often much older) journal.
  const newestJournalId = useMemo(
    () =>
      pickNewestJournalId(
        sortedJournalIds.map(id => ({ id, createdAt: child_journals[id]?.['created-at'] }))
      ),
    [sortedJournalIds, child_journals]
  );

  const journalId = storyEntity && Object.keys(storyEntity || {}).length > 0 && isStoriesLink
    ? storyEntity['journal-ids'][0]
    : actualPathname || store.get(LAST_JOURNAL_ID_KEY) || newestJournalId;

  useEffect(() => {
    revalidateJournals()
    if (journalId) store.set(LAST_JOURNAL_ID_KEY, journalId);
  }, [journalId]);

  let childJournal = child_journals[journalId]


  const path = getResourcePath({
    ...{ id: journalId, type: 'child-journals' }
  });

  const { data: journalData } = useSWR(pathname.includes('certificate') ? null : `${path}`);

  if (journalData?.data?.data?.attributes && !childJournal)
    childJournal = journalData?.data?.data?.attributes;

  useEffect(() => {
    if (storyEntity?.['chapter-id']) {
      setCurrentChapterID(storyEntity?.['chapter-id'])
      setShowOptions(true)
      setSelectedOption('Chapters')
    }
    else
      setCurrentChapterID(locationParams[4])
  }, [locationParams[4], storyEntity?.['chapter-id']])
  const [on, set] = useValue(false);
  const [showMobileJournals, setShowMobileJournals] = useValue(false);
  const { receiveDeletion } = useEntityActionCreators();

  // The switcher groups journals into "children" by first name — the API has no
  // child/parent relationship (see docs/child_journal_editions.md), so this is
  // the same heuristic the "which child is this book about?" creation step uses.
  const switcherJournals = sortedJournalIds
    .filter(id => {
      const name = child_journals[id]?.['subject-name']?.toLowerCase() || '';
      return !name.includes('tap for intro') && !name.includes('sample child journal');
    })
    .map(id => ({
      id,
      firstName: child_journals[id]?.['subject-name'] || child_journals[id]?.['first-name'],
      createdAt: child_journals[id]?.['created-at'],
      subjectId: child_journals[id]?.['subject-id'],
    }));
  const childGroups = useMemo(() => groupJournalsByChild(switcherJournals), [switcherJournals]);

  const activeChildGroup = childGroups.find(group => group.journals.some(j => j.id === journalId));
  const activeBookNumber = activeChildGroup
    ? activeChildGroup.journals.findIndex(j => j.id === journalId) + 1
    : null;

  // Shown once the member has more than one child or book to switch between —
  // not every time they add another (see SWITCHER_FTUE_KEY).
  const [showSwitcherFtue, setShowSwitcherFtue] = useState(false);
  useEffect(() => {
    if (allJournalIds.length > 1 && !store.get(SWITCHER_FTUE_KEY)) setShowSwitcherFtue(true);
  }, [allJournalIds.length]);

  const dismissSwitcherFtue = () => {
    store.set(SWITCHER_FTUE_KEY, true);
    setShowSwitcherFtue(false);
  };

  const onSelectJournal = id => {
    dismissSwitcherFtue();
    receiveDeletion({ entityType: 'chapter' });
    set(false);
    push(`/child-journals/${id}`);
    setCurrentCollection({ id, type: 'child-journals' });
    setShowOptions(false);
    setShowMobileJournals(false);
  };

  useChronicleCollectionSWR();

  const { data, error, revalidate } = useJournalsChaptersSWR(journalId);
  const loading = !data && !error;
  const isPaid = childJournal?.paid || childJournal?.['free-trial'] || childJournal?.['has-baby-year-books-subscription'] || childJournal?.['has-watch-me-grow-subscription']
  const isPublicRoute = checkIfPublicRoute(pathname);
  const chapters = data?.data?.data.sort((a, b) => a.attributes.position - b.attributes.position);

  const route = useRouteFromEntityParams({ id: journalId, type: 'child-journals' });

  // useEffect(() => {
  //   if (isPaid === false)
  //     dispatch(toggleNavigationVisible(false));
  // }, [isPaid])

  useEffect(() => {
    if (revalidateSidebar) revalidate();
  }, [revalidateSidebar]);

  // Reset collection when navigating to specific routes
  useEffect(() => {
    if (['/my-stories', '/shared-with-me', '/'].includes(pathname)) {
      setCurrentCollection(null);
    }
  }, [pathname, setCurrentCollection]);

  if (isPublicRoute) return null;

  function getBookStepName() {
    const queryParams = new URLSearchParams(window.location.search);
    const stepFromUrl = queryParams.get('step');
    if (+stepFromUrl === 1)
      return 'Cover'

    if (+stepFromUrl === 2)
      return 'Organize Stories'

    if (+stepFromUrl === 3)
      return 'Organize Chapters'

    if (+stepFromUrl === 4)
      return 'Book Layout'
  }

  function getBookStep(label) {
    if (label === 'Cover')
      return 1

    if (label === 'Organize Stories')
      return 2

    if (label === 'Organize Chapters')
      return 3

    if (label === 'Book Layout')
      return 4
  }

  // Handle the sidebar toggle logic
  const handleOptionClick = (label) => {
    if (label === 'Chapters') {
      openFirstTimeUserModal(() => setShowOptions(!showOptions))
      setShowWatchMeGrowOptions(false);
      setShowMyBooksOptions(false);
      if (on)
        set(false)
    }
    else if (label === 'Request a Story') {
      dispatch(setSidebar(false))
      if (selectedOption !== 'Request a Story')
        postMemberEvent('tapped_request_a_story', {
          'subject-type': 'ChildJournal',
          'subject-id': journalId,
        })

      replace(`${route}/story-request`);
    }
    else if (label === 'Watch Me Grow') {
      dispatch(setSidebar(false))
      replace(`${route}/watch-me-grow`);
      setShowOptions(false);
      setShowWatchMeGrowOptions(!showWatchMeGrowOptions);
      setShowMyBooksOptions(false);
    }
    else if (label === 'Milestones') {
      dispatch(setSidebar(false))
      replace(`${route}/milestones`);
    }
    else if (label === 'Growth Chart') {
      dispatch(setSidebar(false))
      replace(`${route}/growth-chart`);
    }
    else if (label === 'Talking Family Tree') {
      dispatch(setSidebar(false))
      replace(`${route}/family-tree`);
    }
    else if (label === 'My Book') {
      if (!memberSettings?.['baby-yearbooks-beta-enabled'])
        replace(`${route}/feature-coming-soon/${label.replaceAll(' ', '-')}`);
      else {
        dispatch(setSidebar(false))
        replace(`${route}/book-creation?step=1`);
        setShowOptions(false);
        setShowMyBooksOptions(!showMyBooksOptions);
        setShowWatchMeGrowOptions(false);
      }
    }
    else if (label === "Edit Chapters") {
      openFirstTimeUserModal()
    }
    else if (label !== "Edit Chapters") {
      onCollectionClick();
      replace(route);
      setShowOptions(false);
    }

    previousOptionSelection = selectedOption
    setSelectedOption(label);
    resetCollectionTag();
  };

  const hasAssigned = journals.some((journal) => journal?.state === "initialized");

  if (isPaid === false || !hasAssigned || pathname.includes('account/setup') || pathname === '/gift')
    return null

  if (selectedOption === 'Edit Chapters' && isFromMobile)
    return <CollectionTagManagement
      revalidate={revalidate}
      chapters={chapters}
      journalId={journalId}
      onClose={() => {
        revalidate()
        if (previousOptionSelection === 'Chapters')
          setShowOptions(true);
        setSelectedOption(previousOptionSelection)
      }}
    />

  return (
    <Wrap width={closeSidebar ? "80px" : "270px"} pt={[0, 0, 3]}>

      {setCloseSidebar && <Flex alignItems="center" px={3} css="min-height: 40px;">
        <Image src={closeSidebar ? closeSidebarLogo : wordmark} alt="Baby Yearbooks logo" mx="auto" maxWidth={180} css="display: block;" />
        <Button variant="transparent" onClick={() => setCloseSidebar(!closeSidebar)} css={`position: absolute; right: -24px`}>
          {closeSidebar ? <ExpandIcon /> : <CloseIcon />}
        </Button>
      </Flex>}

      {!closeSidebar && (
        <>
          {isOnFreeTrial && <Button
            p="10px 30px"
            height="-webkit-fill-available"
            minHeight="40px"
            m="auto"
            my={[2, 3]}
            width="max-content"
            sx={{ height: "40px !important", borderRadius: '23px', color: '#fff', fontFamily: 'Poppins', fontWeight: 500, fontSize: '16px', lineHeight: '125%', letterSpacing: '-0.096px' }}
            onClick={() => {
              window.open(childJournal?.['bundle-purchase-url'] + `?email=${encodeURIComponent(member?.email)}`, '_blank')
              // replace(`${route}/paywall?step=1`)
            }}
          >
            Upgrade or give as a gift
          </Button>}

          <Flex m="auto" alignItems="center" my={!setCloseSidebar ? 0 : 3} mt={1} mx={1}>
            <CollectionAvatar isFromSidebar id={journalId} type={'child-journals'} editLink={`${route}/edit`} />
            {showMobileJournals && <Modal
              title="Child"
              shadeProps={{ pt: [0, 4] }}
              close={{
                onClose: () => {
                  const drawer = document.querySelector('.mobile-drawer');
                  drawer.style.overflowY = 'scroll';
                  drawer.style.touchAction = 'auto';
                  setShowMobileJournals(false)
                }
              }}
              footerOffset={60}
            >
              <ChildBookSwitcher
                activeChildJournalName={childJournal?.['first-name']}
                childGroups={childGroups}
                activeJournalId={journalId}
                onSelectJournal={onSelectJournal}
              />
            </Modal>}

            <Flex
              flexDirection="column"
              alignItems="flex-start"
              mx={2}
            >
              <Heading color="#0E0E0E" fontWeight={500} fontSize="16px" fontFamily='Poppins' m="auto" mt={1} css="word-break: break-word;">
                <CollectionTitle id={journalId} type={'child-journals'} />
              </Heading>
              {!!activeBookNumber && (
                <Text fontFamily="Poppins" fontSize="12px" color="#64748B">
                  Book {activeBookNumber}
                </Text>
              )}
            </Flex>


            {allJournalIds.length > 1 &&
              // <Tooltip
              //   placement={isFromMobile ? "bottom" : "right"}
              //   theme="light"
              //   trigger="manual"
              //   visible={showSwitcherFtue}
              //   offset={isFromMobile ? "0, 0" : "0, 50"}
              //   content={
              //     <TooltipWrap style={{ maxWidth: 220 }}>
              //       <Text fontFamily="Poppins" fontSize="14px" mb={2} color="black">
              //         Tap here to switch between children or books
              //       </Text>
              //       <Button
              //         variant="primary"
              //         sx={{ borderRadius: '20px', width: '100%' }}
              //         onClick={dismissSwitcherFtue}
              //       >
              //         Got it!
              //       </Button>
              //     </TooltipWrap>
              //   }
              // >
              <Tooltip
                placement={isFromMobile ? "bottom" : "right"}
                theme="light"
                trigger="manual"
                className="collection-journals-tooltip"
                interactive
                visible={on}
                offset={isFromMobile ? "0, 0" : "0, 50"}
                onHidden={() => on && set(false)}
                content={
                  <TooltipWrap style={{ overflowY: 'auto', minWidth: 260 }}>
                    <ChildBookSwitcher
                      activeChildJournalName={childJournal?.['first-name']}
                      childGroups={childGroups}
                      activeJournalId={journalId}
                      onSelectJournal={onSelectJournal}
                    />
                  </TooltipWrap>
                }
              >
                <Box sx={{ cursor: 'pointer' }} onClick={() => {
                  dismissSwitcherFtue();
                  if (isFromMobile) {
                    const drawer = document.querySelector('.mobile-drawer');
                    drawer.style.overflowY = 'hidden';
                    drawer.style.touchAction = 'none';
                    setShowMobileJournals(true)
                  } else
                    set(true)
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
                    <rect x="33.5833" y="0.75" width="32.6111" height="32.8333" rx="16.3056" transform="rotate(90 33.5833 0.75)" fill="white" />
                    <rect x="33.5833" y="0.75" width="32.6111" height="32.8333" rx="16.3056" transform="rotate(90 33.5833 0.75)" stroke="#D0B0DE" stroke-width="1.5" />
                    <path d="M20.4921 22.2839C20.0582 21.85 20.0582 21.1465 20.4921 20.7126L24.1509 17.0538L20.4921 13.395C20.0582 12.9611 20.0582 12.2576 20.4921 11.8237C20.926 11.3898 21.6295 11.3898 22.0635 11.8237L26.5079 16.2681C26.9418 16.7021 26.9418 17.4056 26.5079 17.8395L22.0635 22.2839C21.6295 22.7179 20.926 22.7179 20.4921 22.2839Z" fill-rule="evenodd" clip-rule="evenodd" fill="#9B59B6" />
                    <path d="M13.8412 11.8254C14.2751 12.2594 14.2751 12.9629 13.8412 13.3968L10.1824 17.0556L13.8412 20.7143C14.2751 21.1482 14.2751 21.8518 13.8412 22.2857C13.4073 22.7196 12.7038 22.7196 12.2698 22.2857L7.82539 17.8412C7.39148 17.4073 7.39148 16.7038 7.82539 16.2699L12.2698 11.8254C12.7038 11.3915 13.4073 11.3915 13.8412 11.8254Z" fill-rule="evenodd" clip-rule="evenodd" fill="#9B59B6" />
                  </svg>
                </Box>
                {/* </Tooltip> */}
              </Tooltip>}
          </Flex>
        </>
      )}
      {!isFromMobile && selectedOption === 'Edit Chapters' && <CollectionTagManagement
        revalidate={revalidate}
        chapters={chapters}
        journalId={journalId}
        onClose={() => {
          revalidate()
          if (previousOptionSelection === 'Chapters')
            setShowOptions(true);
          setSelectedOption(previousOptionSelection)
        }}
      />}
      <Box css="overflow-y: scroll;" mt={closeSidebar && 4}>
        {loading && <Loading local />}

        {SidebarOptions.map(({ icon, label }) => {
          const isSelected = selectedOption === label;
          const iconColor = isSelected ? '#9B59B6' : undefined;
          return (
            <Box key={label}>
              <Flex
                onClick={() => handleOptionClick(label)}
                mx={closeSidebar ? "20px" : "24px"}
                mt={1}
                bg={isSelected && (closeSidebar) ? '#F5EEF8' : 'white'}
                sx={{ borderRadius: '100px', cursor: 'pointer' }}
              >
                {closeSidebar ? (
                  <Flex width="40px" height="40px" margin="auto" justifyContent="center" alignItems="center">
                    {icon(iconColor)}
                  </Flex>
                ) : (
                  <Flex px={3} py={2}>
                    {icon(iconColor)}
                    <Text minWidth={130} ml="12px" fontFamily="Poppins" fontWeight={500} lineHeight="20px" color={isSelected ? "#9B59B6" : "#64748B"}>
                      {label}
                    </Text>
                    {(label === 'Chapters') && (
                      <Box ml="10px" sx={{ cursor: 'pointer' }}>
                        {(showOptions) ? <FaChevronDown color={iconColor} /> : <FaChevronRight color={iconColor} />}
                      </Box>
                    )}
                    {(label === 'Watch Me Grow') && (
                      <Box ml="10px" sx={{ cursor: 'pointer' }}>
                        {showWatchMeGrowOptions ? <FaChevronDown color={iconColor} /> : <FaChevronRight color={iconColor} />}
                      </Box>
                    )}
                    {/* {(label === 'My Book') && (
                      <Box ml="10px" sx={{ cursor: 'pointer' }}>
                        {showMyBooksOptions ? <FaChevronDown color={iconColor} /> : <FaChevronRight color={iconColor} />}
                      </Box>
                    )} */}
                  </Flex>
                )}
              </Flex>
              {!closeSidebar && label === 'Watch Me Grow' && showWatchMeGrowOptions && (
                <Box css="overflow-y: scroll;" >
                  {(WatchMeGrowOptions || []).map(({ icon, label }, index) => {
                    const isOptionSelected = pathname.split('/').includes(label === 'Book Preview' ? 'collage-preview' : label.toLowerCase().replace(/ /g, '-'));
                    const iconColor = isOptionSelected ? '#9B59B6' : undefined;

                    return (
                      <Flex
                        key={label}
                        px={3}
                        py={1}
                        mb={index === WatchMeGrowOptions.length - 1 ? 1 : 0}
                        onClick={() => {
                          replace(`${route}/${label === 'Book Preview' ? 'collage-preview' : label.toLowerCase().replace(/ /g, '-')}`);
                        }}
                        ml="48px"
                        bg={isOptionSelected ? '#F5EEF8' : 'white'}
                        sx={{ borderRadius: '100px', cursor: 'pointer' }}
                      >
                        {icon(iconColor)}
                        <Text ml={1} fontSize="14px" fontFamily="Poppins" fontWeight={500} lineHeight="165%" letterSpacing="0.14px" color={isOptionSelected ? "#9B59B6" : "#64748B"}>
                          {label}
                        </Text>
                      </Flex>
                    );
                  })}
                </Box>
              )}
              {!closeSidebar && label === 'My Book' && showMyBooksOptions && (
                <Box css="overflow-y: scroll;" >
                  {(MyBooksOptions || []).map(({ icon, label }, index) => {
                    const isOptionSelected = label === getBookStepName();
                    const iconColor = isOptionSelected ? '#9B59B6' : undefined;
                    return (
                      <Flex
                        key={label}
                        px={3}
                        py={1}
                        mb={index === MyBooksOptions.length - 1 ? 1 : 0}
                        onClick={() => {
                          replace(`${route}/book-creation?step=${getBookStep(label)}`);
                        }}
                        ml="48px"
                        bg={isOptionSelected ? '#F5EEF8' : 'white'}
                        sx={{ borderRadius: '100px', cursor: 'pointer' }}
                      >
                        {icon(iconColor)}
                        <Text ml={1} fontSize="14px" fontFamily="Poppins" fontWeight={500} lineHeight="165%" letterSpacing="0.14px" color={isOptionSelected ? "#9B59B6" : "#64748B"}>
                          {label}
                        </Text>
                      </Flex>
                    );
                  })}
                </Box>
              )}
              {!closeSidebar && label === 'Chapters' && showOptions && (
                <Box css="overflow-y: scroll;" mb={2}>
                  {(chapters || []).map(({ attributes }, index) => {
                    const isOptionSelected = currentChapterId === attributes.id;
                    return (
                      <Flex
                        key={attributes.id}
                        px={3}
                        py={1}
                        onClick={() => {
                          if (onCollectionClick)
                            onCollectionClick();

                          replace(`${route}/chapters/${attributes?.id}`)
                        }}
                        ml="55px"
                        bg={isOptionSelected ? '#F5EEF8' : 'white'}
                        sx={{ borderRadius: '100px', cursor: 'pointer' }}
                      >
                        <Text fontSize="14px" fontFamily="Poppins" mr={1} color={isOptionSelected ? "#9B59B6" : "#64748B"}>
                          {index + 1}.
                        </Text>
                        <Text fontSize="14px" fontFamily="Poppins" fontWeight={500} lineHeight="165%" letterSpacing="0.14px" color={isOptionSelected ? "#9B59B6" : "#64748B"}>
                          {attributes?.name}
                        </Text>
                      </Flex>
                    );
                  })}
                </Box>
              )}
            </Box>
          );
        })}
        <Box css="overflow-y: scroll;" mt={closeSidebar && 4} sx={{
          borderTop: '1px solid #E2E8F0'
        }}>
          {ExtrasSection(replace, route).map(({ icon, label, onClick }) => {
            return <Box key={label}>
              <Flex
                onClick={onClick}
                mx={closeSidebar ? "20px" : "24px"}
                my={1}
                bg='white'
                sx={{ borderRadius: '100px', cursor: 'pointer' }}
              >
                {closeSidebar ? (
                  <Flex width="40px" height="40px" margin="auto" justifyContent="center" alignItems="center">
                    {icon()}
                  </Flex>
                ) : (
                  <Flex px={3} py={2}>
                    {icon()}
                    <Text ml="12px" fontFamily="Poppins" fontWeight={500} lineHeight="20px" color="#64748B">
                      {label}
                    </Text>
                  </Flex>
                )}
              </Flex>
            </Box>
          })}
        </Box>
        <Box css="overflow-y: scroll;" mt={closeSidebar && 4} mb={8} sx={{
          borderTop: '1px solid #E2E8F0'
        }}>
          <MeLink
            isSelected={selectedOption === 'profile'}
            closeSidebar={closeSidebar}
            setCloseSidebar={setCloseSidebar}
            journalId={journalId}
          />
        </Box>
      </Box>
    </Wrap>
  );
};

NavigationSidebar.propTypes = {
  onCollectionClick: PropTypes.func,
};

NavigationSidebar.defaultProps = {
  onCollectionClick: () => { },
};

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: ${props => props.width};
  max-width: ${props => props.width};
  min-width: ${props => props.width};
  background-color: ${props => props.theme.colors.drawerBg};
  box-shadow: 0 16px 44px 0 rgba(0, 0, 0, 0.07);
  ${space};
`;

export default NavigationSidebar;
